import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';
import { Button } from './ui/button';
import testimonialsBgImg from '../assets/testimonials-bg.webp';
import avatar1Img from '../assets/avatar-1.webp';
import avatar2Img from '../assets/avatar-2.webp';
import avatar3Img from '../assets/avatar-3.webp';

const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      text: 'Outstanding care combined with a warm, welcoming environment. The team is highly knowledgeable patients, making every visit a positive experience.',
      author: 'Michael Smith',
      location: 'San Francisco, CA'
    },
    {
      text: 'A caring team and a comforting atmosphere. They go above and beyond to make sure every patient feels valued and well cared for truly cares and makes every visit pleasant.',
      author: 'Stephanie Johnson',
      location: 'Los Angeles, CA'
    },
    {
      text: 'Absolutely amazing with kids. She keeps my children calm and comfortable during every visit. The office is bright, fun, and welcoming, making dental care.',
      author: 'Gregg Lewis',
      location: 'San Diego, CA'
    }
  ];

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-16 lg:py-24 bg-gray-50 relative overflow-hidden">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left - Image & Stats */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={testimonialsBgImg}
                alt="Patient care"
                className="w-full h-full object-cover"
                loading="lazy"
                decoding="async"
                width="600"
                height="500"
              />
            </div>
            <div className="absolute bottom-6 left-6 bg-white rounded-xl p-6 shadow-xl">
              <div className="flex items-center space-x-3 mb-2">
                <div className="flex -space-x-2">
                  <img
                    src={avatar1Img}
                    alt="Patient"
                    className="w-10 h-10 rounded-full border-2 border-white object-cover"
                  />
                  <img
                    src={avatar2Img}
                    alt="Patient"
                    className="w-10 h-10 rounded-full border-2 border-white object-cover"
                  />
                  <img
                    src={avatar3Img}
                    alt="Patient"
                    className="w-10 h-10 rounded-full border-2 border-white object-cover"
                  />
                </div>
                <div>
                  <p className="text-2xl font-bold text-gray-900">4.9k</p>
                </div>
              </div>
              <p className="text-gray-600 text-sm">Customer experiences that speak for themselves</p>
            </div>
          </div>

          {/* Right - Testimonials */}
          <div>
            <div className="inline-flex items-center space-x-2 bg-[#1e3a8a]/5 px-4 py-2 rounded-full mb-4">
              <div className="w-2 h-2 bg-[#22d3ee] rounded-full"></div>
              <span className="text-[#1e3a8a] text-sm font-semibold uppercase tracking-wide">Client Reviews</span>
            </div>
            
            <h2 className="text-3xl lg:text-5xl font-bold text-gray-900 mb-8 leading-tight">
              What Our Patients Say About Us
            </h2>

            {/* Testimonial Card */}
            <div className="bg-white rounded-2xl p-8 shadow-lg mb-6">
              <Quote className="h-12 w-12 text-[#22d3ee] mb-4" />
              <p className="text-gray-700 text-lg leading-relaxed mb-6">
                {testimonials[currentIndex].text}
              </p>
              <div>
                <p className="font-bold text-gray-900 text-lg">{testimonials[currentIndex].author}</p>
                <p className="text-gray-500">{testimonials[currentIndex].location}</p>
              </div>
            </div>

            {/* Navigation */}
            <div className="flex items-center space-x-4">
              <Button
                aria-label="Previous testimonial"
                onClick={prevSlide}
                variant="outline"
                size="icon"
                className="rounded-full hover:bg-[#22d3ee] hover:text-white hover:border-[#22d3ee] transition-all duration-300"
              >
                <ChevronLeft className="h-5 w-5" />
              </Button>
              <Button
                aria-label="Next testimonial"
                onClick={nextSlide}
                variant="outline"
                size="icon"
                className="rounded-full hover:bg-[#22d3ee] hover:text-white hover:border-[#22d3ee] transition-all duration-300"
              >
                <ChevronRight className="h-5 w-5" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;